import { FC } from 'react'

import { LogoProps } from '@assets/logo/types'

export const TMEuropeLogo: FC<LogoProps> = ({ className }) => (
  <svg
    className={className}
    width='157'
    height='32'
    viewBox='0 0 157 32'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_6765_67)'>
      <path
        d='M17.4811 20.5038H12.4176C11.8024 20.5038 11.2347 20.176 10.9276 19.6438L8.01763 14.604C7.71054 14.0718 7.71054 13.4161 8.01763 12.8829L10.9276 7.8431C11.2347 7.31088 11.8034 6.98306 12.4176 6.98306H17.4791L21.4999 0.0167862C21.414 0.0108617 21.3291 0 21.2422 0H9.41187C8.16278 0 7.00749 0.666511 6.38246 1.74873L0.468779 11.9942C-0.15626 13.0764 -0.15626 14.4095 0.468779 15.4917L6.38344 25.7372C7.00848 26.8194 8.16278 27.4859 9.41286 27.4859H21.2432C21.3311 27.4859 21.417 27.475 21.5029 27.4691L17.4821 20.5048L17.4811 20.5038Z'
        fill='#FF0044'
      />
      <path
        d='M30.1863 11.994L24.2716 1.74848C24.2282 1.67245 24.1758 1.60333 24.1265 1.53125L20.1057 8.49554L22.6384 12.8817C22.9455 13.4139 22.9455 14.0695 22.6384 14.6028L20.1076 18.9869L24.1284 25.9522C24.1768 25.8811 24.2291 25.813 24.2726 25.7369L30.1873 15.4914C30.8123 14.4092 30.8123 13.0762 30.1873 11.994H30.1863Z'
        fill='#28F981'
      />
      <path
        d='M45.4479 22.1188H41.4774V7.89494H36.1246V4.52783H50.8254V7.89494H45.4479V22.1188Z'
        fill='var(--text-white)'
      />
      <path d='M57.4105 22.1188H53.4401V4.52783H57.4105V22.1188Z' fill='var(--text-white)' />
      <path
        d='M69.7483 22.3964C67.1001 22.3964 64.9021 21.5294 63.1504 19.7945C61.4007 18.0616 60.5258 15.8873 60.5258 13.2726C60.5258 10.726 61.4175 8.58626 63.2007 6.85235C64.985 5.11745 67.2176 4.25049 69.8994 4.25049C72.5131 4.25049 74.8247 5.231 76.8351 7.19103L74.5235 10.0309C73.1164 8.4895 71.5919 7.71931 69.9498 7.71931C68.4578 7.71931 67.1939 8.22585 66.1551 9.23994C65.1163 10.253 64.597 11.5801 64.597 13.2222C64.597 13.9272 64.7076 14.6086 64.9297 15.2711C65.1509 15.9317 65.4866 16.5271 65.9349 17.0544C66.3832 17.5827 66.9431 18.0013 67.6126 18.3124C68.283 18.6214 69.0611 18.7765 69.9498 18.7765C71.5247 18.7765 73.0493 18.0823 74.5235 16.691L76.8598 19.2287C74.6657 21.3398 72.2949 22.3964 69.7483 22.3964Z'
        fill='var(--text-white)'
      />
      <path
        d='M96.0099 22.1188H91.2603L86.184 14.9066L83.671 17.6961V22.1188H79.7006V4.52783H83.671V12.7195L90.9582 4.52783H95.5833L88.9478 11.8407L96.0099 22.1188Z'
        fill='var(--text-white)'
      />
      <path
        d='M118.425 22.1188H114.857V10.2322L109.855 20.3335H107.292L102.266 10.2322V22.1188H98.6976V4.52783H103.12L108.599 15.3342L114.026 4.52783H118.424L118.425 22.1188Z'
        fill='var(--text-white)'
      />
      <path d='M126.769 22.1188H122.799V4.52783H126.769V22.1188Z' fill='var(--text-white)' />
      <path
        d='M142.65 22.1188H131.141V4.52783H135.112V18.6509H142.65V22.1188Z'
        fill='var(--text-white)'
      />
      <path
        d='M157 22.1188H145.492V4.52783H149.462V18.6509H157V22.1188Z'
        fill='var(--text-white)'
      />
      <path
        d='M127.268 31.8613H122.782V26.0898H127.177V27.1701H124.085V28.4231H126.864V29.5034H124.085V30.7811H127.268V31.8613Z'
        fill='var(--text-white)'
      />
      <path
        d='M130.723 31.9522C130.269 31.9522 129.845 31.8682 129.451 31.6984C129.057 31.5296 128.736 31.257 128.488 30.8798C128.257 30.5174 128.142 30.0504 128.142 29.4787V26.0898H129.444V29.4787C129.444 29.9349 129.571 30.2716 129.827 30.4888C130.083 30.706 130.383 30.8147 130.73 30.8147C131.07 30.8147 131.363 30.708 131.608 30.4928C131.852 30.2785 131.975 29.9408 131.975 29.4787V26.0898H133.277V29.4787C133.277 30.0395 133.166 30.5026 132.943 30.868C132.704 31.2501 132.39 31.5266 132.001 31.6964C131.612 31.8663 131.186 31.9522 130.721 31.9522H130.723Z'
        fill='var(--text-white)'
      />
      <path
        d='M139.42 31.8613H137.945L137.029 30.2123H135.702V31.8613H134.4V26.0898H136.907C137.346 26.0898 137.745 26.156 138.105 26.2903C138.463 26.4236 138.75 26.6408 138.969 26.944C139.172 27.2382 139.273 27.6213 139.273 28.0943C139.273 28.979 138.912 29.6001 138.194 29.9576L139.421 31.8623L139.42 31.8613ZM136.906 29.1242C137.658 29.1242 138.036 28.7944 138.036 28.1348C138.036 27.492 137.658 27.1701 136.906 27.1701H135.701V29.1242H136.906Z'
        fill='var(--text-white)'
      />
      <path
        d='M143.007 31.9522C142.132 31.9522 141.398 31.6678 140.801 31.0991C140.205 30.5303 139.907 29.8194 139.907 28.9682C139.907 28.117 140.202 27.4081 140.792 26.8452C141.384 26.2814 142.121 26 143.007 26C143.897 26 144.636 26.2844 145.225 26.8531C145.813 27.4219 146.107 28.1269 146.107 28.9682C146.107 29.8194 145.812 30.5303 145.221 31.0991C144.63 31.6678 143.892 31.9522 143.007 31.9522ZM143.023 30.8147C143.234 30.8147 143.444 30.7772 143.65 30.7011C143.857 30.6251 144.044 30.5115 144.213 30.3595C144.382 30.2064 144.517 30.0149 144.619 29.7818C144.72 29.5488 144.771 29.2782 144.771 28.9682C144.771 28.5782 144.689 28.2484 144.524 27.9788C144.348 27.6954 144.128 27.4851 143.862 27.3459C143.597 27.2076 143.317 27.1375 143.023 27.1375C142.561 27.1375 142.149 27.3073 141.787 27.648C141.424 27.9887 141.243 28.4291 141.243 28.9672C141.243 29.5113 141.421 29.9546 141.779 30.2983C142.136 30.6419 142.551 30.8147 143.023 30.8147Z'
        fill='var(--text-white)'
      />
      <path
        d='M148.217 31.8613H146.914V26.0898H149.364C149.892 26.0898 150.326 26.1738 150.667 26.3416C151.007 26.5095 151.261 26.7435 151.426 27.0447C151.591 27.3449 151.673 27.6954 151.673 28.0943C151.673 28.4873 151.595 28.8438 151.44 29.1637C151.285 29.4836 151.034 29.7413 150.687 29.9368C150.35 30.1205 149.908 30.2133 149.365 30.2133H148.219V31.8623L148.217 31.8613ZM149.298 29.1242C150.056 29.1242 150.436 28.7944 150.436 28.1348C150.436 27.492 150.056 27.1701 149.298 27.1701H148.218V29.1242H149.298Z'
        fill='var(--text-white)'
      />
      <path
        d='M156.941 31.8613H152.455V26.0898H156.85V27.1701H153.758V28.4231H156.537V29.5034H153.758V30.7811H156.941V31.8613Z'
        fill='var(--text-white)'
      />
    </g>
    <defs>
      <clipPath id='clip0_6765_67'>
        <rect width='157' height='32' fill='white' />
      </clipPath>
    </defs>
  </svg>
)
